import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  CheckItemsPayload,
  KitRelabelConfirmationPayload,
  KitRelabelResponse,
  KitRelabelStickerPayload,
  KitRelabelStickerResponse,
  OrderData,
  OrdersData,
  PrintBlankPayload,
} from './types'

export class DeliveryService {
  static getShippingOrders(): Promise<AxiosResponse<OrdersData>> {
    return apiService.get<AxiosResponse<OrdersData>>('/shipping/orders')
  }

  static getShippingOrderById(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OrderData>> {
    return apiService.get<AxiosResponse<OrderData>>(`/shipping/${id}`, config)
  }

  static printBlanc(
    data: PrintBlankPayload,
    orderId: string,
    action: string,
  ): Promise<AxiosResponse> {
    return apiService.post(`/shipping/${orderId}/${action}`, data)
  }

  static checkingItemsOrderById(
    orderId: string,
    data: CheckItemsPayload,
  ): Promise<AxiosResponse> {
    return apiService.post(`/shipping/${orderId}/checking`, data)
  }

  static getProductByBarcode(barcode: string): Promise<AxiosResponse> {
    return apiService.get<AxiosResponse>(
      `/products/variation/barcode/${barcode}`,
    )
  }

  static getKitRelabel(
    orderId: string,
  ): Promise<AxiosResponse<KitRelabelResponse>> {
    return apiService.get<AxiosResponse<KitRelabelResponse>>(
      `/shipping/${orderId}/kit-relabel`,
    )
  }

  static printKitRelabelSticker(
    orderId: string,
    data: KitRelabelStickerPayload,
  ): Promise<KitRelabelStickerResponse> {
    return apiService.post<KitRelabelStickerResponse>(
      `/shipping/${orderId}/kit-relabel/stickers`,
      data,
    )
  }

  static confirmKitRelabel(
    orderId: string,
    data: KitRelabelConfirmationPayload,
  ): Promise<KitRelabelResponse> {
    return apiService.post<KitRelabelResponse>(
      `/shipping/${orderId}/kit-relabel/confirmations`,
      data,
    )
  }

  static validateMarks(
    orderId: string,
    data: { itemId: string; [key: string]: string },
  ): Promise<AxiosResponse> {
    return apiService.post(`/shipping/${orderId}/validate-marks`, data)
  }

  static reprintMandatoryMark(
    orderId: string,
    data: { itemId: string; identificationCode: string },
  ): Promise<AxiosResponse<Blob>> {
    return apiService.postBlob(
      `/shipping/${orderId}/mandatory-mark-reprints`,
      data,
    )
  }

  static getMandatoryMarksCsv(orderId: string): Promise<AxiosResponse<Blob>> {
    return apiService.getBlob(`/shipping/${orderId}/mandatory-marks`)
  }
}
